import { CompanyDataResult } from "./types";

/* The report screens' Companies filter, as it lives in the URL.

   The filter value is the CIK -- the people view knows companies by CIK
   alone, and private companies have no ticker to go by. But a bare CIK makes
   an unreadable chip, and Vote Analytics' answer (redraw the chip from the
   ticker) fails for exactly those private companies. So each entry carries
   its own label: "cik|AAPL — Apple Inc.". The chip reads the label; the API
   wrapper sends only the CIK. */

export interface ReportCompany {
  cik: number;
  label: string;
}

export function encodeCompany(r: CompanyDataResult): string {
  const label: string = r.ticker
    ? `${r.ticker} — ${r.company_name}`
    : r.company_name;
  return `${r.company_cik}|${label}`;
}

/* Tolerant of what a URL round trip hands back: queryString.parse returns a
   single repeated value as a bare string rather than a one-element array, and
   the report parsers numerize -- so an entry can arrive as a string, an array,
   or (should a label ever be dropped) a plain number. */
export function decodeCompanies(value: unknown): ReportCompany[] {
  if (value === undefined || value === null || value === "") return [];
  const entries: unknown[] = Array.isArray(value) ? value : [value];
  return entries
    .map((e) => {
      const [cik, ...rest] = String(e).split("|");
      return { cik: Number(cik), label: rest.join("|") || String(cik) };
    })
    .filter((c) => Number.isInteger(c.cik) && c.cik > 0);
}

export function companyCiks(value: unknown): number[] {
  return decodeCompanies(value).map((c) => c.cik);
}
